<template>
  <div  class="bg-light container-fluid p-2 container">
    <p style="font-size:18;" class="font-weight-bold">{{ title }}</p>
    <div class="d-flex justify-content-between">
      <input
        class="bg-light"
        id="input-url"
        v-on:focus="$event.target.select()"
        ref="clone"
        readonly
        :value="link_url"
      />      
      <button @click="copy" class="btn btn-primary">
        <i class="fa-regular fa-clipboard"></i>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isCopied: false,
    };
  },
  props: {
    link_url: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    }
  },
  methods: {
    copy() {
      this.$refs.clone.focus();
      document.execCommand("copy");
      this.showCopiedMessage()
    }
    
  },
};
</script>

<style>
  #input-url{
    border: 0;
    resize: horizontal;
    width:500px;
    cursor: default;
  
  }
</style>
